import { useContext } from 'react';
import { SetContext } from '../hoc/SetProvider';

export function useSet() {
	const context = useContext(SetContext);
	if (context === null) {
		throw new Error('useSet must be used within a SetProvider');
	}
	return context;
}
